"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newLinePinComponent = void 0;
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
const pin_component_1 = require("./pin-component");
const linePinComponentDefaultSize = (0, geometry_1.newSize)(75, 0);
function newLinePinComponent({ start = pin_component_1.initialPinComponentPosition, end = (0, geometry_1.newVector)(start.x + linePinComponentDefaultSize.width, start.y + linePinComponentDefaultSize.height), settings, order = order_1.defaultOrder, }) {
    return {
        type: 'LINE',
        id: (0, random_id_1.randomId)(),
        settings: {
            tailMarker: 'NONE',
            headMarker: 'NONE',
            ...settings,
        },
        layout: (0, geometry_1.newLine)(start, end),
        order,
    };
}
exports.newLinePinComponent = newLinePinComponent;
//# sourceMappingURL=line-pin-component.js.map